import { APICore, API_URL } from './apiCore';

const api = new APICore();

const getAgentsByUser = (userId: string) => {
    const relativeUrl = `/insurance-company-agent/user/${userId}`;
    return api.get(`${API_URL}${relativeUrl}`, {});
};

const createAgent = (data: { userId: string; companyId: string; agentIdType: string; agentId: string }) => {
    const relativeUrl = '/insurance-company-agent';
    return api.create(`${API_URL}${relativeUrl}`, data);
};

const updateAgent = (
    agentEntryId: string,
    data: {
        agentId?: string;
        agentIdType?: string;
        companyId?: string;
    },
) => {
    const relativeUrl = `/insurance-company-agent/${agentEntryId}`;
    return api.update(`${API_URL}${relativeUrl}`, data);
};

const deleteAgent = (agentEntryId: string) => {
    const relativeUrl = `/insurance-company-agent/${agentEntryId}`;
    return api.delete(`${API_URL}${relativeUrl}`);
};

export { getAgentsByUser, createAgent, updateAgent, deleteAgent };
